import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16f22fcd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/views/dashboard/messages/index.scss?vue&type=style&index=0&id=16f22fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f22fcd",
  null
  
)

export default component.exports